import React, { FC } from "react";
import { Display } from "stentor-models";
import { isCarousel, isForm, isList } from "../../utils/guards";
import { SearchResponseCarouselDisplay } from "../SearchResponseCarouselDisplay";
import { SearchResponseListDisplay } from "../SearchResponseListDisplay";
import { FormDisplay } from "../FormDisplay";
import { FormNextData, FormStepUpdateDisplay } from "../FormDisplay/model";

export interface ResponseDisplayProps {
    readonly display: Display;
    readonly loading: boolean;
    onActionResponse(data: unknown, action: string): void;
    onTrackNextStep?: (stepName: string, stepIndex: number, stepData: Record<string, unknown>, isLastStep: boolean) => void;
    onTrackPreviousStep?: (fromStepName: string, fromStepIndex: number, toStepName: string, toStepIndex: number) => void;
    onTrackSubmit?: (stepName: string, stepIndex: number, completedData: Record<string, unknown>, totalSteps: number) => void;
    /**
     * Callback to track a FORM_SUBMIT dispatch that failed outright (issue #1373).
     */
    onTrackSubmitFailure?: (stepName: string, stepIndex: number, totalSteps: number, reason: string) => void;
    currentStepDataRef?: React.MutableRefObject<Record<string, unknown>>;
    /** Zero-based step to open the form on, instead of the first. */
    readonly initialStep?: number;
    /** Open the date/time step on the soonest day that has times. */
    readonly preselectFirstAvailableDate?: boolean;
    /** Fired with the step index when initialStep is applied. */
    onTrackInitialStep?: (stepIndex: number) => void;
    onFormNext?: (data: FormNextData) => Promise<unknown>;
    stepUpdate?: FormStepUpdateDisplay;
    onTrackHandoffRendered?: (stepName: string, provider: string) => void;
    onTrackHandoffNoRender?: (stepName: string, provider: string) => void;
    onTrackHandoffScheduled?: (stepName: string, provider: string, payload?: unknown) => void;
    onTrackHandoffError?: (stepName: string, provider: string) => void;
}

// TODO: Rename this to ResponseDisplay
export const ResponseDisplay: FC<ResponseDisplayProps> = (props) => {
    const {
        display,
        onActionResponse,
        loading,
        onTrackNextStep,
        onTrackPreviousStep,
        onTrackSubmit,
        onTrackSubmitFailure,
        currentStepDataRef,
        initialStep,
        preselectFirstAvailableDate,
        onTrackInitialStep,
        onFormNext,
        stepUpdate,
        onTrackHandoffRendered,
        onTrackHandoffNoRender,
        onTrackHandoffScheduled,
        onTrackHandoffError,
    } = props;

    // TODO: Do we need these others? isList and isCarousel?
    return (
        <div className="xapp-search-response-display">
            {isForm(display) && (
                <FormDisplay
                    form={display}
                    loading={loading}
                    onActionResponse={onActionResponse}
                    onTrackNextStep={onTrackNextStep}
                    onTrackPreviousStep={onTrackPreviousStep}
                    onTrackSubmit={onTrackSubmit}
                    onTrackSubmitFailure={onTrackSubmitFailure}
                    currentStepDataRef={currentStepDataRef}
                    initialStep={initialStep}
                    preselectFirstAvailableDate={preselectFirstAvailableDate}
                    onTrackInitialStep={onTrackInitialStep}
                    onFormNext={onFormNext}
                    stepUpdate={stepUpdate}
                    onTrackHandoffRendered={onTrackHandoffRendered}
                    onTrackHandoffNoRender={onTrackHandoffNoRender}
                    onTrackHandoffScheduled={onTrackHandoffScheduled}
                    onTrackHandoffError={onTrackHandoffError}
                />
            )}
            {isList(display) && <SearchResponseListDisplay list={display} />}
            {isCarousel(display) && <SearchResponseCarouselDisplay carousel={display} />}
        </div>
    );
};
